<script>
	import { onMount, onDestroy } from 'svelte';
	import TimerBar from './TimerBar.svelte';
	import WaitingFor from './WaitingFor.svelte';
	import Container from './Container.svelte';

  import Editor from './Editor.svelte';

	export let getTask;

	let capture, release, test, submit, problem;
	let allocatedTime;

	let solving;
	let visibleTestFeedback;
	let hiddenTestFeedback;

	let remainingTime;
	let interval;
	let timeout;
	let submission;

	const updateTask = async () => {
		[capture, test, submit, problem, allocatedTime, remainingTime, visibleTestFeedback, hiddenTestFeedback] = new Array(8);
		solving = false;

		if (timeout) {
			clearTimeout(timeout);
		}
		if (interval) {
			clearInterval(interval);
		}

		let releaseFn = await getTask((problemObj, captureFn, releaseFn) => {
			[problem, capture, release] = [problemObj, captureFn, releaseFn];
			submission = problem.signature;

			allocatedTime = 30;
			remainingTime = 30;

			timeout = setTimeout(async () => await updateTask(), 30000)
			interval = setInterval(() => {remainingTime -= Math.min(remainingTime, 0.1)}, 100)
		});
		if (releaseFn) {
			release = releaseFn;
		}
	}

	const captureTask = async () => {
		if (timeout) {
			clearTimeout(timeout);
		}
		solving = true;
		test = await capture();
		if (test) {
			allocatedTime = problem.max_capture_time*60;
			remainingTime = allocatedTime;
		} else {
			await updateTask()
		}
	}

	const testTask = async () => {
		[submit, visibleTestFeedback, hiddenTestFeedback] = await test(submission);
		console.log(visibleTestFeedback, hiddenTestFeedback)
	}
	const submitTask = async () => {
		await submit();
		await updateTask();
	}
	const releaseTask = async () => {
		await release();
		await updateTask();

	}

	onMount(async () => {
		await updateTask();
	})
	onDestroy( () => {
		if (release) {
			release().then(console.log);
		}
		if (interval) {
			clearInterval(interval);
		}
		if (timeout) {
			clearTimeout(timeout);
		}
	});
</script>

<Container>
	{#if remainingTime}
		<TimerBar fullnessPercent={remainingTime/allocatedTime*100} />
	{/if}
		{#if problem}
			{#if solving}
				<h2>Solving Task</h2>

				<h3>Submission</h3>
				<Editor bind:text={submission} readOnly={false} language="python"/>
			{:else}
				<h2>Can you solve this for ${problem.price} in less than {problem.max_capture_time} min?</h2>

				<h3>Target Signature</h3>
				<Editor text={submission} readOnly={true} language="python"/>
			{/if}


			<h3>Validation Test</h3>
			<Editor text={problem.visible_test} language="python" readOnly={true}/>

			{#if visibleTestFeedback}
				<Editor 
					bind:text={visibleTestFeedback} 
					language="python" 
					readOnly={true} 
					color={visibleTestFeedback.toLowerCase().includes('error')? '#800' :  '#080'}
					backgroundColor={visibleTestFeedback.toLowerCase().includes('error')? '#fcc' :  '#cfc'}
					/>
			{/if}



			<div style="margin: 100px"/>
			Task may contain hidden tests as well.
			{#if visibleTestFeedback}
				<p style="color: {hiddenTestFeedback == 'passed'? '#080' :  '#800'};">
				Sumission {hiddenTestFeedback == 'passed' ? 'passed' : 'did not pass' } the hidden tests </p>
			{/if}

			<div>
				<button on:click={releaseTask} class='pure-button'>Skip</button>
				{#if solving} 
					<button on:click={testTask} class='pure-button'>Test solution</button>
					{#if submit}
						<button on:click={submitTask} class='pure-button pure-button-primary' style='background-color: var(--primary-color);'>Submit solution</button>
					{/if}
				{:else}
					<button on:click={captureTask} class='pure-button pure-button-primary' style='background-color: var(--primary-color);'>Yes, lets start!</button>
				{/if}
			</div>

		{:else}
			<WaitingFor message="Waiting for a task to work on" style="font-size: 30px; font-weight: 100"/>
		{/if}
</Container>

<svelte:window on:keydown={(e) => {
	if (solving) {
		// console.log(e)
	}
}}/>

<style>
  h2, h3 {
    font-weight: 100;
  }
</style>
